<template>
    <div>
        <p>
            Selecteer een periode
        </p>
        <a-range-picker :placeholder="['Start dag', 'Eind dag']" v-model="date" @change="onChange" />
        <div v-if="reservationsLoading"  class="w-100 d-flex justify-content-center align-items-center">
            <a-spin size="large" />
        </div>
        <div class="mt-3" v-if="organizations.length > 0">
          <p>Beschikbare Organisaties</p>
          <a-table :columns="columns" :data-source="organizations" >
            <!-- <a slot="action" slot-scope="text" href="javascript:;">Delete</a> -->
                <p class="mb-0" slot="reservations_amount" slot-scope="reservations">{{reservations.length}}</p>
                <p class="mb-0" slot="departments_amount" slot-scope="departments"><span v-if="departments">{{departments.length}}</span></p>
            <div slot="expandedRowRender" slot-scope="organization" style="margin: 0">
              <h6>Reservations</h6>
              <a-table rowKey="id" :data-source="organization.reservations" :pagination="false" :columns="reservationColumns" :row-selection="{ selectedRowKeys: selectedOrganizationInvoicesRowKeys, onChange: onSelectChange }">
                <p class="mb-0" slot="name" slot-scope="name">{{name.first_name}} {{name.last_name}}</p>
                <p class="mb-0" slot="aankomst" slot-scope="dates">{{moment(dates.departure_time).format('DD-MM-YYYY HH:mm')}}</p>
                <p class="mb-0" slot="retour" slot-scope="dates">{{moment(dates.arrival_time).format('DD-MM-YYYY HH:mm')}}</p>
              </a-table>
              <h6 class="mt-3 mb-2"  v-if="organization.departments">Afdelingen</h6>
              <a-table v-if="organization.departments" :data-source="organization.departments" :pagination="false" :columns="columns">
                <p class="mb-0" slot="reservations_amount" slot-scope="reservations">{{reservations.length}}</p>
                <p class="mb-0" slot="departments_amount" slot-scope="departments">{{departments.length}}</p>
                <!-- <a slot="action" slot-scope="text" href="javascript:;">Delete</a> -->
                <div slot="expandedRowRender" slot-scope="department" style="margin: 0">
                  <a-table rowKey="id" :data-source="department.reservations" :columns="reservationColumns" :row-selection="{ selectedRowKeys: selectedOrganizationInvoicesRowKeys, onChange: onSelectChange }" />
                </div>
              </a-table>
            </div>
          </a-table>
        </div>
        <div class="mt-3" v-if="organizations.length > 0">
          <a-button type="primary" @click="generateInvoices()" :loading="generateLoading">
            Genereer facturen
          </a-button>
          <a-checkbox class="ml-3" v-model="sendInvoiceToCustomer">
            Verstuur facturen per mail
          </a-checkbox>
        </div>
    </div>
</template>
<script>
const columns = [
  { title: 'Name', dataIndex: 'name', key: 'name' },
  { title: 'Aantal Reserveringen', dataIndex: 'reservations', scopedSlots: { customRender: 'reservations_amount' }, key: 'reservations_amount' },
  { title: 'Aantal Afdelingen', dataIndex: 'departments', scopedSlots: { customRender: 'departments_amount' }, key: 'departments_amount' },
  { title: 'Action', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]
const reservationColumns = [
  { title: 'Reserveringsnummer', dataIndex: 'reserveringsnummer', key: 'id' },
  { title: 'Naam', scopedSlots: { customRender: 'name' }, key: 'name' },
  { title: 'Aankomst', scopedSlots: { customRender: 'aankomst' }, key: 'dates' },
  { title: 'Retour', scopedSlots: { customRender: 'retour' }, key: 'dates' },
  { title: 'License Plate', dataIndex: 'license_plate', key: 'address' },
  { title: 'Action', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]
export default {
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      organizations: [],
      columns,
      reservationColumns,
      date: undefined,
      generateLoading: false,
      selectedOrganizationInvoicesRowKeys: [],
      reservationsLoading: false,
      sendInvoiceToCustomer: true,
    }
  },
  methods: {
    generateInvoices(){
      this.generateLoading = true;
      this.$axios.post('/invoice/generateInvoiceByReservationIds', {
        reservation_ids: this.selectedOrganizationInvoicesRowKeys,
        sendInvoiceToCustomer: this.sendInvoiceToCustomer,
      },
      {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        }
      }).then(response=>{
        console.log('generateInvoiceByReservationIds', response.data);
        this.onChange(undefined, this.date);
        this.generateLoading = false;
      })
    },
    onChange(date, dateString) {
      this.reservationsLoading = true;
      this.$axios.get('/invoice/showAvailableReservations', {
        params: {
          startDate: dateString[0],
          endDate: dateString[1],
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.organizations = response.data
        
        this.reservationsLoading = false;
        let reservationIdArray = []
        response.data.map((data) => {
          if (data.reservations.length > 0) {
            data.reservations.map((reservation) => {
              reservationIdArray.push(reservation.id)
            })
          }
          if (data.departments && data.departments.length > 0) {
            data.departments.map((department) => {
              if (department.reservations.length > 0) {
                department.reservations.map((reservation) => {
                  reservationIdArray.push(reservation.id)
                })
              }
            })
          }
        })
        this.selectedOrganizationInvoicesRowKeys = reservationIdArray;
        console.log(reservationIdArray);
      })
    },
    onSelectChange(selectedRowKeys, i) {
      console.log('selectedRowKeys changed: ', selectedRowKeys, i)
      this.selectedOrganizationInvoicesRowKeys = selectedRowKeys
    },
  },
}
</script>
